import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { StorageMap } from '@ngx-pwa/local-storage';
import { throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { StorageHelper } from './storage.helper';

// import { device, screen, isAndroid, isIOS } from "tns-core-modules/platform";

// import { DeviceInfo } from 'nativescript-dna-deviceinfo';

@Injectable({
    providedIn: 'root'
  })

export class AuthService {

    storageService = new StorageHelper();

    baseUrl = `${environment.basePath}`;
    userServiceUrl = `${environment.userService}`;
    notificationServiceUrl = `${environment.notificationService}`;
    tenantKey = `${environment.tenantKey}`;

    requestId = "x2slls33";             //temp

    facebookGraphAPIUrl = "https://graph.facebook.com/v7.0/";

    constructor(
        private http: HttpClient,
        private storage: StorageMap,
    ) { 
        this.storageService = new StorageHelper();
    }

    setTenantKey(tenant) {
        this.tenantKey = tenant;
    }

    getCall() {
        let otpUrl = "";

        let headers = new HttpHeaders({
            "AuthKey": "my-key",
            "AuthToken": "my-token",
            "Content-Type": "application/json",
         });

        return this.http.get(otpUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    login(email, password, organizationKey?:string) {
        let otpUrl = this.userServiceUrl + "/oauth/token";

        let myHeaders = new HttpHeaders({
            "Authorization": "Basic YXBwX3VzZXI6cGFzc3dvcmQ=",
            "Content-Type": "application/x-www-form-urlencoded",
         });         

        //  const urlencoded = new HttpParams({
        //     fromObject: {
        //       grant_type: 'password',
        //       "username": email,
        //       "password": password,
        //       "tenantKey": this.tenantKey
        //     }
        //   });

        //   const urlencoded = new FormData();
        //   urlencoded.append("grant_type", "password");
        //   urlencoded.append("username", email);
        //   urlencoded.append("password", password);
        //   urlencoded.append("tenantKey", this.tenantKey);

         const urlencoded = "grant_type=password&username="+encodeURIComponent(email)+"&password="+password+"&organizationKey="+organizationKey;

        //const urlencoded = "grant_type=password&username="+encodeURIComponent(email)+"&password="+password+"&organizationKey="+organizationKey;

        return this.http.post(otpUrl, urlencoded, { headers: myHeaders })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    forgotPassword(email) { 
        let otpUrl = this.userServiceUrl + "/forgot-password";

        let myHeaders = new HttpHeaders({
            "Authorization": "Basic YXBwX3VzZXI6cGFzc3dvcmQ=",
            "Content-Type": "application/json",
         });

         var body = {
             "userName": email,
             "tenantKey":this.tenantKey
        }

        return this.http.post(otpUrl, body, { headers: myHeaders })
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getWelcomeSlides() {
        let locUrl = this.userServiceUrl + "/kennel/" + this.tenantKey + "/sliders";
        let headers = new HttpHeaders({
            "Content-Type": "application/json",
         });
         console.log(locUrl)
        return this.http.get(locUrl, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    signUp(userObj) {
        console.log(userObj,'service');
        
        var deviceType = "WEB";

        userObj["tenantKey"] = this.tenantKey;
        userObj["platform"] = deviceType;
        userObj["source"] = deviceType;
        this.storageService.setItem('email', userObj.email);
        this.storageService.setItem('no', userObj.mobileNumber);


        console.log(userObj,'service 2');
        
        // userObj["device"] = DeviceInfo.deviceName();
        // userObj["timeZone"] = DeviceInfo.timezone();
        
        let otpUrl = this.userServiceUrl + "/" + this.tenantKey + "/register?sendInvite=true";

        let headers = new HttpHeaders({
            "Content-Type": "application/json"
         });
        
         return this.http.post(otpUrl, userObj, { headers: headers })
         .pipe(
             map((res:Response) => res),
             catchError((error:any) => throwError(error || 'Server error'))
         )
    }

    signUp_branch(user) {
        var deviceType = "WEB";

        user["tenantKey"] = this.tenantKey;
        user["platform"] = deviceType;
        // user["device"] = DeviceInfo.deviceName();
        // user["timeZone"] = DeviceInfo.timezone();

        let locUrl = this.userServiceUrl + "/invite";
        let headers = new HttpHeaders({
            "Content-Type": "application/json",
         });
         console.log(locUrl);
        return this.http.put(locUrl, user, {headers : headers})
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    getFbData(token) {
        let locUrl = this.facebookGraphAPIUrl + "/me?access_token=" + token + " &fields=id,name,picture.type(large),first_name,last_name,email";

        return this.http.get(locUrl)
        .pipe(
            map((res:Response) => res),
            catchError((error:any) => throwError(error || 'Server error'))
        )
    }

    authFromFacebook(userObj) {
        var deviceType = "WEB";

        userObj["tenantKey"] = this.tenantKey;
        userObj["platform"] = deviceType;
        // userObj["device"] = DeviceInfo.deviceName();
        // userObj["deviceToken"] = device.uuid;
        // userObj["timeZone"] = DeviceInfo.timezone();

        let otpUrl = this.userServiceUrl + "/authenticate/facebook?platform=" + deviceType;

        let headers = new HttpHeaders({
            "Content-Type": "application/json",
            "RequestID" : this.requestId
         });
        
         return this.http.post(otpUrl, userObj, { headers: headers })
         .pipe(
             map((res:Response) => res),
             catchError((error:any) => throwError(error || 'Server error'))
         )
    }

    authFromGoogle(userObj) {
        var deviceType = "WEB";

        userObj["tenantKey"] = this.tenantKey;
        userObj["platform"] = deviceType;
        // userObj["device"] = DeviceInfo.deviceName();
        // userObj["deviceToken"] = device.uuid;
        // userObj["timeZone"] = DeviceInfo.timezone();

        let otpUrl = this.userServiceUrl + "/authenticate/google?platform=" + deviceType;

        let headers = new HttpHeaders({
            "Content-Type": "application/json",
            "RequestID" : this.requestId
         });
        
         return this.http.post(otpUrl, userObj, { headers: headers })
         .pipe(
             map((res:Response) => res),
             catchError((error:any) => throwError(error || 'Server error'))
         )
    }
}
